import * as React from "react"
import { connect } from "react-redux"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"

import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"
import SimpleSearchField from "./SimpleSearchField"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { ISearch } from "../index"

type StateProps = ISearch

type Props = StateProps & DispatchProps

export class SimpleSearch extends React.Component<Props> {
    render(): JSX.Element {
        const { isShown } = this.props

        return (
            <>
                <Action
                    id="showSearchButton"
                    name="showSearchButton"
                    onClick={this.showSearch}
                    actionType={ActionType.icon}
                    extraClasses="is-inverted"
                >
                    {Symbols.Search}
                </Action>
                <Modal
                    isShown={isShown}
                    containerProps={{
                        isTopFixedPositioned: true,
                        onClose: this.hideSearch,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore: JSX data-attributes are not supported in nested object types https://github.com/microsoft/TypeScript/issues/28960
                        "data-ft-application-search": true,
                    }}
                >
                    <SimpleSearchField />
                </Modal>
            </>
        )
    }

    hideSearch = (): void => {
        const { updateVisibility } = this.props
        updateVisibility(false)
    }

    showSearch = (): void => {
        const { updateVisibility } = this.props
        updateVisibility(true)
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.search

export default connect(mapStateToProps, mapDispatchToProps)(SimpleSearch)
